/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2NlcmYvY29tcG9uZW50cy9jZXJmLXJlcG9ydC9jZXJmLXJlcG9ydC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9jZXJmL2NvbXBvbmVudHMvY2VyZi1yZXBvcnQvY2VyZi1yZXBvcnQuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/cerf/components/cerf-report/cerf-report.component.scss.shim.ngstyle.ts